import script from "./deliOnceImg7.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg7.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg7.vue?vue&type=style&index=0&id=e2abc8e2&lang=less"

const __exports__ = script;

export default __exports__